var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',[_c('OtherLoading',{attrs:{"variant":"dark"}})],1):_c('div',[_c('PrivilegeSet',{attrs:{"detail":_vm.privilegeSet}}),_c('div',{staticClass:"content-set-privilege mt-3"},[_c('PrivilegeSetList',{attrs:{"idPrivilege":_vm.privilegeSet.id,"list":_vm.privilegeSet.tag_coupon}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }